import React from 'react';
import { Container } from '@material-ui/core';

import illustration from '@/assets/images/illustration-bidding-done.svg';

export function ViewBiddingDone() {
  return (
    <Container
      style={{
        background: '#f7f9ff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        height: '100vh',
      }}
      maxWidth="sm"
    >
      <img src={illustration} alt="bidding done" />
      <p className="my-12 pt-12 mx-24 text-center font-weight-700">
        Maaf, Bidding Sudah Selesai
      </p>
      <p className="my-0 mx-24 text-center">
        Pesanan sudah diterima oleh apotek lain. Terima kasih telah
        berpartisipasi!
      </p>
    </Container>
  );
}
